var productCardMarkup = `
 {{#products}}
<article class="favorite">
      <div class="favorite__main">
      <div class="favorite__main-inner"><a class="favorite__image" href="{{du}}">
                    <picture><img class=" lazyloaded" src="" data-srcset="{{iu}}" alt="" srcset="{{iu}}">
          </picture></a>
                  <div class="favorite__info">
          <div class="favorite__info-inner">
            <h2 class="favorite__info-title"><a class="favorite__info-title-trigger" href="{{du}}">
            <span class="favorite__info-brand">{{bt}}</span>
            <span class="favorite__info-name">{{dt}}</span></a></h2>




              <div class="price ">
                <div>
                  <div class="price__regular">
                    <span class="visually-hidden visually-hidden--inline">通常価格</span>
                    <span class="price-item price-item--regular">
                      <span class="price-notax">{{pr}}</span>円　(税込<span class="price-intax">{{pr}}</span>円)

                    </span>
                  </div>
                  <div class="price__sale">
                    <div class="regular_price">
                      <span class="visually-hidden visually-hidden--inline">通常価格</span>


                      <span>
                        <s class="price-item price-item--regular">
                          0円
                          (税込円)
                          </s>
                      </span>
                    </div><div class="sale_price">
                      <span class="visually-hidden visually-hidden--inline">セール価格</span>

                      {{pr}}円　(税込{{pr}}円)

                    </div>
                  </div>

                  </small>
                </div></div>

            <p class="favorite__info-delete">
              <button class="favorite__info-delete-trigger" type="button" onclick="removeList('{{epi}}','{{empi}}','{{du}}','{{iu}}','{{pr}}','{{stk}}','{{variants}}','{{listId}}')">リストから削除</button>
            </p>
          </div>
        </div>
      </div>
    </div>
 </article>
 {{/products}}
`;


//  <ul>
//  {{#products}}
// 	<li class="wish__item">
//         <a href="{{du}}">
//       <div class="grid-view-item product-card">
//           <span class="visually-hidden">{{dt}}</span>
//         <div class="grid-view-item__image-wrapper product-card__image-wrapper js">
//           <div style="padding-top: 66.66666666666666%;">
//             <img  class="grid-view-item__image lazyautosizes" src="{{iu}}" />
//           </div>
//         </div>
//       <div class="h4 grid-view-item__title product-card__title" aria-hidden="true">{{dt}} - {{variantinfo}}</div>

// {{bt}}
// {{vi}}

//         <dl class="price" data-price="">
//           <span class="price-item price-item--sale" data-sale-price="">
//             {{cu}}{{pr}}
//           </span>
//         </dl>
//       </div>
//         </a>
//     </li>
//   {{/products}}
//  </ul>



// window.onload = function() {
//   var cl = document.getElementsByClassName('pc');
//   console.log(cl);
//   console.log(cl.length);
//   console.log(cl[0]);
// };
// window.onload = function() {
//   var price = document.getElementsByClassName('price');
//   console.log(price);
//   console.log(price.length);
//   console.log(price[0]);
// };



// var price = document.getElementsByClassName('price')[0].innerHTML;

// console.log(price)

// console.log(price.toString().replace('.00', ''));

// // price = price.replace('.00', '');
// document.getElementsByClassName('price').innerHTML = price;
function removeList(epi,empi,du,iu,pr,stk,variants,listId) {
  window._swat.removeFromWishList(
    {
      "epi": epi,
      "du": du,
      "empi": empi,
      "iu" :iu,
      "pr": pr,
      "stk": stk,
      "variants": variants
    },
    function (r) {
      location.reload()
    }
  );
}

// function removeList(epi,empi,du,listId) {
//   console.log(listId);
//   var listItemMap = {
//     epi: epi,  // unique epi per listid
//     empi: empi,
//     du: du
//   };

//   _swat.deleteFromList(listId, listItemMap, function (deletedListItem) {
//     // successfully deleted list item
//     callback(deletedListItem);
//   }, function (xhrObj) {
//     // something went wrong
//   });
// }

function getVariantInfo(variants){
  try {
    let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []) , variantinfo;
    if(variantKeys.length > 0){
      variantinfo = variantKeys[0];
      if(variantinfo == "Default Title"){
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch(err){
    return variants;
  }
}

function swymCallbackFn(){
  // gets called once Swym is ready
  var wishlistContentsContainer = document.getElementById("wishlist-items-container");
  _swat.fetchWrtEventTypeET(
    function(products) {
      // Get wishlist items
      var formattedWishlistedProducts = products.map(function(p){
        p = SwymUtils.formatProductPrice(p);    // formats product price and adds currency to product Object
        p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
        p.variantinfo = (p.variants ? getVariantInfo(p.variants) : "");
        return p;
      });



      //ブランド名取得
      var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {products: formattedWishlistedProducts});
      wishlistContentsContainer.innerHTML = productCardsMarkup;
      var cl_brand = document.getElementsByClassName('favorite__info-brand');

      for (i = 0; i < cl_brand.length; i++) {
        //JSONからブランド名称取得
        var link_url = document.getElementsByClassName('favorite__image')[i].href;
        var brand_name = getProductJSON(link_url+'.json');
        document.getElementsByClassName("favorite__info-brand")[i].innerHTML = brand_name;
      }

    //JSONからブランド名を取得
    function getProductJSON(jsonURL) {
      $.ajaxSetup({ async: false });// 非同期にする
      $.getJSON(jsonURL, function (product) {
        brand_name = product.product.vendor;
      });
      return brand_name;
      $.ajaxSetup({ async: true }); // 非同期に戻す
    }




      // URL取得
      // TODO: JSONをVanillajsで取得したい
      // var cl_brand = document.getElementsByClassName('favorite__info-brand');
      // for (i = 0; i < cl_brand.length; i++) {
      //   //JSONからブランド名称取得
      //   var jsonURL = "https://ataoland.com/products/atao-sj.json";

      //   var jsongetJSONData(jsonURL, function (json) {
      //     brand = json.product.vendor;
      //     document.body.innerHTML = brand_name;

      //     // brand = json.product.vendor;
      //     // console.log(brand);
      //   });

      //   document.getElementsByClassName("favorite__info-brand")[i].innerHTML = brand_name;

      // }


      // //JSON data 取得（Vanilla）
      // function getJSONData(url, callback) {
      //   var xhr = new XMLHttpRequest();
      //   xhr.onerror = function () {
      //     console.log("error");
      //   };
      //   xhr.onreadystatechange = function () {
      //     if (this.readyState === 4 && this.status === 200) {
      //       var response = this.response;
      //       if (typeof response === "string") {
      //         response = JSON.parse(response);
      //       }

      //       callback(response);
      //     }
      //   };
      //   xhr.open("GET", url, true);
      //   xhr.responseType = "json";
      //   xhr.send();
      // }







      //通貨フォーマット（税抜）
      var cl_price = document.getElementsByClassName('price-notax');
      for (i = 0; i < cl_price.length; i++) {
        var clstr = cl_price[i].innerHTML;
        let num = clstr / 1.1;
        num = Math.ceil( num ) ;
        var clstr = String(num);
        clstr = clstr.replace('.00', '' ).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
        document.getElementsByClassName("price-notax")[i].innerHTML = clstr;
      }


      //通貨フォーマット（税込）
      var cl_price = document.getElementsByClassName('price-intax');
      for (i = 0; i < cl_price.length; i++) {
        var clstr = cl_price[i].innerHTML;
        clstr = clstr.replace('.00', '' ).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');;
        document.getElementsByClassName("price-intax")[i].innerHTML = clstr;
      }

      attachClickListeners();

    },
    window._swat.EventTypes.addToWishList
  );
}
if(!window.SwymCallbacks){
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymCallbackFn);


function onAddToCartClick(e){
  e.preventDefault();
  var productId = e.target.getAttribute("data-product-id");
  var variantId = e.target.getAttribute("data-variant-id");
  var du = e.target.getAttribute("data-url");
  e.target.innerHTML = "Adding..";
  window._swat.replayAddToCart(
   {empi: productId, du: du},
   variantId,
   function() {
     e.target.innerHTML = "Moved to cart";
     window.location.reload();
     console.log("Successfully added product to cart.");
   },
   function(e) {
     console.log(e);
   }
  );
}


function attachClickListeners(){
  var addToCartButtons = document.getElementsByClassName("add-to-cart");

  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
  }
}
